module.exports = __webpack_public_path__ + "static/media/wine-toast-1000x1000.0db55a37.jpg";